import React, { useEffect, useState } from 'react';
import { useFetchHistoryLog } from '../hooks/useFetchHistoryLog';
import { PaginationComponent, Spinner } from '../../../../../Components';
import { AccordionTable } from '../../../LeaseTransactionJourney/Utilities';
import { RequestTypeEnum } from '../../../../../Enums';
import ChangedFieldsTables from './ChangedFieldsTables';
import { isEqual } from 'lodash';

const HistoryLogTable = ({ developerContactId, parentTranslationPath }) => {
  const { data, error, loading, fetchHistoryLog } = useFetchHistoryLog();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  useEffect(() => {
    fetchHistoryLog(developerContactId, pagination);
  }, [pagination]);

  const findRequestType = (requestType) =>
    RequestTypeEnum.find((item) => item.key === requestType).value ?? 'Read';
  const getExpandedRowContent = (row) => {
    const responseAfterChanged = JSON.parse(row.responseAfterChanged).developer;
    const response = JSON.parse(row.response).developer;
    row.changeFields = [];
    if (responseAfterChanged && response) {
      Object.keys(responseAfterChanged).forEach((key) => {
        if (!isEqual(response[key], responseAfterChanged[key])) {
          if (typeof responseAfterChanged[key] === 'object') {
            const activeKey = ['email', 'phone', 'name', 'lookupItemName'].find(
              (keyPath) =>
                typeof responseAfterChanged[key] === 'object' &&
                keyPath in responseAfterChanged[key]
            );
            if (activeKey) {
              row.changeFields.push({
                fieldName: key.replaceAll('_', ' '),
                changedFrom: response[key]?.[activeKey],
                changedTo: responseAfterChanged[key][activeKey],
              });
            }
          } else if (
            ['string', 'number'].includes(typeof responseAfterChanged[key])
          ) {
            row.changeFields.push({
              fieldName: key.replaceAll('_', ' '),
              changedFrom: response[key],
              changedTo: responseAfterChanged[key],
            });
          }
        }
      });
    }
    if (row.changeFields.length === 0) {
      return <h4 className='text-center'>No changes detected</h4>;
    }

    return (
      <ChangedFieldsTables
        changedFields={row.changeFields}
        parentTranslationPath={parentTranslationPath}
      />
    );
  };
  const onPageIndexChanged = (pageIndex) => {
    setPagination((prev) => ({
      ...prev,
      pageIndex,
    }));
  };
  const onPageSizeChanged = (pageSize) => {
    setPagination((prev) => ({
      ...prev,
      pageSize,
    }));
  };
  if (loading) {
    return <Spinner isActive />;
  }
  return (
    <>
      <AccordionTable
        headerData={[
          {
            label: 'date_and_time',
            input: 'createdOn',
            isDate: true,
            dateFormat: 'DD/MM/YYYY HH:mm A',
          },
          { label: 'user', input: 'createdByName' },
          {
            label: 'type',
            input: 'requestType',
            component: (row) => findRequestType(row.requestType),
          },
        ]}
        getIsExpandableRow={(row) => row.responseAfterChanged}
        getExpandedRowContent={getExpandedRowContent}
        data={data?.result}
        expandedComponentClassname={'p-0'}
        parentTranslationPath={parentTranslationPath}
      />
      <PaginationComponent
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        totalCount={data.totalCount}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
      />
    </>
  );
};
export default HistoryLogTable;
